export default {
  destructure: (distanceObj) => {
    let distance = 0;
    if (!distanceObj.distance) return [distance, "m"];
    else {
      const [value, unit] = distanceObj.distance.split(" ");

      return [parseFloat(value), unit];
    }
  },

  structure: (value, unit) => {
    return `${value} ${unit}`;
  },

  toKm: (distanceArr) => {
    return distanceArr[1] === "m" ? distanceArr[0] / 1000 : distanceArr[0];
  },
};
